import { _ as _objectWithoutProperties, a as _extends } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';

var styles = {
raw: ".hcr-box-1-6-0{margin-bottom:12px;padding:12px;border:1px solid #e1e1e1;border-radius:5px;background:#fff}@media (min-width:600px){.hcr-box-1-6-0{padding:24px}}.hcr-box--highlighted-1-6-0{border:0;-webkit-box-shadow:0 0 12px rgba(0,0,0,.12);box-shadow:0 0 12px rgba(0,0,0,.12)}",
map:{"hcr-box":"hcr-box-1-6-0","hcr-box--highlighted":"hcr-box--highlighted-1-6-0"}};

var bem = Bem('box', styles);
var Box = function Box(_ref) {
  var children = _ref.children,
      highlighted = _ref.highlighted,
      extraClasses = _ref.extraClasses,
      rest = _objectWithoutProperties(_ref, ["children", "highlighted", "extraClasses"]);

  var boxClassNames = bem.b({
    highlighted: highlighted
  }, extraClasses);
  return React.createElement("div", _extends({
    className: boxClassNames
  }, rest), children);
};
Box.displayName = 'Box';
Box.defaultProps = {
  highlighted: null,
  extraClasses: ''
};
Box.propTypes = {
  /** Content of the box */
  children: PropTypes.node.isRequired,

  /** Creates a Highlighted box */
  highlighted: PropTypes.bool,

  /** Injection in className */
  extraClasses: PropTypes.string
};
var box = Injecss(Box, styles);

export { box as Box };
